<template>
  
    <div class="product-content">
      <el-dialog title="" 
      :visible.sync="dialogVisible" 
      @close="dialogFormVisible" 
      :close-on-click-modal="false" 
      :close-on-press-escape="false"
      width="80%"
      top="2vh"
      >
      <div style="margin-bottom: 10px;">
        <el-button @click="quick_zk" size="small">快速展开</el-button>
        <el-button @click="quick_zd" size="small">快速折叠</el-button>
        <el-button @click="quick_gw" size="small">快速归位</el-button>
    </div>
      <div id="app">
        <el-scrollbar ref="ref_scrollbar" style="height:75vh;">
        <TreeChart   v-drag="{type:'name',obj:curObj}" 
      style="position: relative;"
      :style="'top:' + top + 'px;left:' + left + 'px;'" isChild="no" :model="tree"  
      @on-update="update" 
      @on-clear="clear"
      />
      </el-scrollbar>
      </div>
      </el-dialog>
    </div>
  </template>
  
  <script>
import TreeChart from './TreeChart'
import UserApi from '@/api/user.js';
  export default {
    data() {
      return {
        tree: {},
        dialogVisible:false,
        /*当前对象*/
        curObj:this,
        left:"",
        top:"",
      };
    },
    props: ['open_edit', 'user_id'],
    components: {
        TreeChart
    },
    created() {
        this.dialogVisible = this.open_edit
        this.getUser();
    },
    directives: {
    /*拖动指令*/
    drag: {
      inserted: function(el, binding) {
        let self = this;
        el.onmousedown = function(event) {
          event = event || window.event;
          let diffX = event.clientX - el.offsetLeft;
          let diffY = event.clientY - el.offsetTop;

          /*鼠标移动*/
          document.onmousemove = function(event) {
            event = event || window.event;
            let moveX = event.clientX - diffX;
            let moveY = event.clientY - diffY;
            binding.value.obj.dragDiv(moveX,moveY,binding.value.type);
          };

          /*鼠标弹起*/
          document.onmouseup = function(event) {
            document.onmousemove = null;
            document.onmouseup = null;
          };
        };
      }
    }
  },
    methods: {
      quick_gw(){
      this.left=0;
      this.top=0;
    },
    quick_zk(){
      this.getUser(true);
      this.quick_gw();
    },
    quick_zd(){
      this.getUser(false);
      this.quick_gw();
    },
      /*拖动赋值*/
      dragDiv(x, y,type) {
  
    if(type=='name'){
    this.left=x;
    this.top=y;
  }

},
    getUser(flag = false){
      var self = this;

      UserApi.getUserTree({
        user_id:self.user_id,
        flag:flag
      }, true)
        .then(data => {
          console.log(data)
          self.tree = data.data
        })
        .catch(error => {});
    },
    clear(e){
      var user_id = "";
      for(var i=0;i<e.children.length;i++){
        user_id+= ","+e.children[i].user_id
      }
      user_id = user_id.substring(1,user_id.length).trim()
      var self = this;
      UserApi.setLabelBz({
        user_id:user_id,
        branded_zone:0,
      }, true)
        .then(data => {
          console.log(data)
          self.getUser(true);
        })
        .catch(error => {});
    },
    // 修改
    update: function(e,branded_zone){
      var user_id = e.user_id;
      var branded_zone = branded_zone;
      var self = this;

      UserApi.setLabelBz({
        user_id:user_id,
        branded_zone:branded_zone
      }, true)
        .then(data => {
          console.log(data)
          self.getUser(true);
        })
        .catch(error => {});
    },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          });
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          });
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .el-dialog__body{
    text-align: left;
  }
  #app{
    height: 100%;
    width: 100%;
    padding: 10px;
 
  }
  </style>
  


// WEBPACK FOOTER //
// src/views/user/tree/part/new.vue